<template>
  <b-card
    class="news-details-generated-page"
    no-body
  >
    <b-card-header class="border-bottom">
      <b-card-title class="font-weight-bold text-secondary font-medium-3 d-flex justify-content-between w-100">
        <div class="">
          {{ gpData.title }}
        </div>   <div
          v-if="gpData.totalGenerated"
          class="font-small-3 mt-0"
        >
          Total: {{ gpData.totalGenerated? gpData.totalGenerated.toLocaleString() : 'n/a' }} ( {{ gpData.totalGeneratedIFrame ? gpData.totalGeneratedIFrame.toLocaleString() : 0 }} Clicked, {{ gpData.totalGenerated && gpData.totalGeneratedIFrame ? (Number(gpData.totalGenerated) - Number(gpData.totalGeneratedIFrame)).toLocaleString() : 0 }} Infinite )
        </div>
      </b-card-title>
    </b-card-header>
    <div class="mt-2 mb-2">
      <b-row class="match-height mx-1 font-medium-1 font-weight-bold text-dark">
        <b-col cols="9">
          {{ gpData.tableLeftTitle }}
        </b-col>
        <b-col v-if="gpData.tableMiddleTitle" cols="3">
          {{ gpData.tableMiddleTitle }}
        </b-col>
      </b-row>
      <b-row
        v-for="(item, index) in gpData.list"
        :key="`gp-item-${index}`"
        class="match-height mx-1 mt-1 font-medium-1"
      >
        <b-col
          cols="9"
        >
          {{ item.pageUrl }}
        </b-col>
        <b-col
          v-if="Number(item.totalInfinite) === 0"
          cols="3"
        >
          {{ item.total.toLocaleString() }} Clicked
        </b-col>
        <b-col
          v-else-if="Number(item.total) === Number(item.totalInfinite)"
          cols="3"
        >
          {{ item.totalInfinite.toLocaleString() }} Infinite
        </b-col>
        <b-col
          v-else
          cols="3"
        >
          {{ (Number(item.total) - Number(item.totalInfinite)).toLocaleString() }} Clicked, {{ item.totalInfinite.toLocaleString() }} Infinite
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
    BRow, BCol, BCard, BCardTitle, BCardHeader, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardTitle,
        BCardHeader,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        gpData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {}
    },
}
</script>
